import { styles } from 'consts';
import styled, { css } from 'styled-components';

const { fontMBank, white, progressBarGradient } = styles;

const isVisibleButton = ({ isVisible }: { isVisible: boolean }) => {
  if (isVisible)
    return {
      opacity: 1,
    };

  return {
    opacity: 0,
    'pointer-events': 'none',
  };
};

export const Container = styled.button<{ isVisible: boolean }>`
  ${isVisibleButton};
  border: none;
  width: 100%;
  height: 2.5rem;
  border-radius: 0.6875rem;
  background-image: ${progressBarGradient};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  transition: opacity 400ms ease-in-out;
  outline: none;
  font-family: ${fontMBank};
  font-size: 1rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${white};

  &::-moz-focus-inner {
    border: 0;
  }
`;

export const LoaderWrapper = styled.div<{ height: number }>`
  ${props =>
    props.height &&
    css`
      height: ${props.height}px;
    `}
`;
